import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ReservationsService } from "../../services/reservations.service";
import * as XLSX from 'xlsx-js-style';
import { AppAttributesService } from "../../services/app-attributes.service";
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-monthly-invoice-reports',
  templateUrl: './monthly-invoice-reports.component.html',
  styleUrls: ['./monthly-invoice-reports.component.scss']
})
export class MonthlyInvoiceReportsComponent implements OnInit {

  searchText: string = '';
  isShow = false;
  filters_form: FormGroup;

  contracts: any[] = [];
  stations: any[] = [];
  reservationStatusList = [
    {
      resStatusId: "A",
      resCustText: "Concierge Assigned",
      resBoText: "Assigned"
    },
    {
      resStatusId: "C",
      resCustText: "Completed Service",
      resBoText: "Completed"
    },
    {
      resStatusId: "E",
      resCustText: "Error with Credit Card",
      resBoText: "Error CC"
    },
    {
      resStatusId: "I",
      resCustText: "Greet In Process",
      resBoText: "In Progress"
    },
    {
      resStatusId: "P",
      resCustText: "Pending Credit Card Details",
      resBoText: "Pending CC"
    },
    {
      resStatusId: "R",
      resCustText: "Canceled without Charges",
      resBoText: "Canx No Charge"
    },
    {
      resStatusId: "U",
      resCustText: "Confirmed Booking",
      resBoText: "Unassigned"
    },
    {
      resStatusId: "W",
      resCustText: "Wait Listed not Confirmed",
      resBoText: "Wait Listed"
    },
    {
      resStatusId: "X",
      resCustText: "Canceled with Charges",
      resBoText: "Canx Charge"
    }
  ];
  yesNoOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ];
  defaultData = {
    summary: {
      totalOfBookingsWithCancellations: 0,
      totalBookingsExecutedCharged: 0,
      totalCancelledBookingsCharged: 0,
      totalCancelledComp: 0,
      totalExpense: 0
    },
    destinations: [],
    bookingBreakdown: []
  }
  monthlyInvoice = this.defaultData;
  constructor(
      private http: HttpClient,
      private fb: FormBuilder,
      private reservationsService: ReservationsService,
      private appAttrService: AppAttributesService,
      private spinner: NgxSpinnerService
  ) {
    this.filters_form = this.fb.group({
      resType: [null],
      resStatusIds: [[]],
      startDate: [null],
      endDate: [null],
    });
  }

  ngOnInit() {
    this.init();
  }

  init() {
    this.spinner.show();
    const startDate = moment().startOf('month').format('YYYY-MM-DD');
    const endDate = moment().endOf('month').format('YYYY-MM-DD');
    this.contracts = this.appAttrService.getContractsWithRetail();
    this.stations = this.appAttrService.getAppAttributes().stations;
    this.reservationsService.monthlyInvoiceReport({
      startDate,
      endDate,
      "resType": null,
      "transStatusId": "U",
      "resStatusIds": ["C", "X"]
    }).subscribe(res => {
     this.monthlyInvoice = res['result'] || this.defaultData;
      setTimeout(() => { this.spinner.hide(); }, 1000);
    })
  }

  showFilter() {
    this.isShow = !this.isShow;
  }

  exportExcel() {
    const borderStyle = {
      top: { style: 'thin', color: { rgb: "000000" } },
      bottom: { style: 'thin', color: { rgb: "000000" } },
      left: { style: 'thin', color: { rgb: "000000" } },
      right: { style: 'thin', color: { rgb: "000000" } }
    };

    const headerStyle = {
      font: { bold: true },
      alignment: { horizontal: 'center', vertical: 'center' },
      border: borderStyle
    };

    const grayFill = {
      fill: { fgColor: { rgb: "BFBFBF" } },
      border: borderStyle
    };

    const greenFill = {
      fill: { fgColor: { rgb: "C6E0B4" } },
      border: borderStyle
    };

    const yellowFill = {
      fill: { fgColor: { rgb: "FFF2CC" } },
      border: borderStyle
    };

    // ===== 1. Summary =====
    const summaryRows = [
      ['Total no. of bookings (with cancellations):', this.monthlyInvoice.summary.totalOfBookingsWithCancellations],
      ['Total no. of bookings executed (charged):', this.monthlyInvoice.summary.totalBookingsExecutedCharged],
      ['Total no. of bookings cancelled with charge (charged):', this.monthlyInvoice.summary.totalCancelledBookingsCharged],
      ['Total no. of bookings cancelled/comp (no charge):', this.monthlyInvoice.summary.totalCancelledComp],
      ['Total expense ($):', `$${this.monthlyInvoice.summary.totalExpense.toLocaleString()}`]
    ].map(row => row.map(cell => ({
      v: cell,
      s: { ...grayFill, border: borderStyle }
    })));

    const summaryData = [
      [{ v: 'Summary:', s: { font: { bold: true }, border: borderStyle } }, { v: '', s: { border: borderStyle } }],
      ...summaryRows,
      []
    ];

    // ===== 2. Destinations =====
    const destCodes = this.monthlyInvoice.destinations.map(d => d.code);
    const destHeader = [{ v: 'Airport', s: headerStyle }, ...destCodes.map(c => ({ v: c, s: headerStyle }))];

    const metricsRows = [
      ['Total No. of bookings', ...this.monthlyInvoice.destinations.map(d => d.metrics.bookings)],
      ['Total No. of passengers', ...this.monthlyInvoice.destinations.map(d => d.metrics.passengers)],
      ['Total No. of Arrival Service', ...this.monthlyInvoice.destinations.map(d => d.metrics.arrivalService)],
      ['Total No. of Departure Service', ...this.monthlyInvoice.destinations.map(d => d.metrics.departureService)],
      ['Total No. of Transfer Service', ...this.monthlyInvoice.destinations.map(d => d.metrics.transferService)]
    ].map(row => row.map((cell, idx) => ({
      v: cell,
      s: idx === 0 ? { ...grayFill, font: { bold: true } } : grayFill
    })));

    const destData = [
      [{ v: 'Destinations:', s: { font: { bold: true }, border: borderStyle } }],
      destHeader,
      ...metricsRows,
      []
    ];

    // ===== 3. Booking Breakdown =====
    const bookingHeader = [
      'Booking ID', 'Service Type', 'Service date', 'Airport', 'No. of pax',
      "Passenger's Last Name (First 3 Letters)", 'Service Base Cost',
      'Additional Hours Service Cost', 'Cancelation Fee', 'Total Service Cost', 'Notes'
    ].map(h => ({ v: h, s: headerStyle }));

    const bookingRows = this.monthlyInvoice.bookingBreakdown.map(b => [
      b.ResID,
      b.ServiceDirectionID === 'A' ? 'Arrival' : b.ServiceDirectionID === 'D' ? 'Departure' : 'Transfer',
      this.dateTranfor(b.StartDT),
      b.AirportIATA,
      b.NumPax,
      b.PassengerCode,
      `$${b.TotalServiceLineAmount}`,
      b.AdditionalServicesAmount ? `$${b.AdditionalServicesAmount}` : '',
      b.CancellationFeeAmount ? { v: `$${b.CancellationFeeAmount}`, s: yellowFill } : { v: '', s: yellowFill },
      { v: `$${b.TotalCost}`, s: greenFill },
      b.AdditionalNotes || ''
    ].map((cell, idx) => {
      if (typeof cell === 'object') return cell;
      return { v: cell, s: { border: borderStyle } };
    }));

    const bookingData = [
      [{ v: 'Booking breakdown:', s: { font: { bold: true }, border: borderStyle } }],
      bookingHeader,
      ...bookingRows
    ];

    const finalData = [...summaryData, ...destData, ...bookingData];
    const worksheet = XLSX.utils.aoa_to_sheet(finalData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

    XLSX.writeFile(workbook, `monthly_invoice_report_Export-${moment().utc().format('YYYY-MM-DD HH:MM:SS')}.xlsx`);
  }

  onFilter(filters: any) {
    this.spinner.show();
    const startDate = filters.startDate
        ? moment(filters.startDate).format('YYYY-MM-DD')
        : moment().startOf('month').format('YYYY-MM-DD');

    const endDate = filters.endDate
        ? moment(filters.endDate).format('YYYY-MM-DD')
        : moment().endOf('month').format('YYYY-MM-DD');
    this.reservationsService.monthlyInvoiceReport({
      startDate,
      endDate,
      resType: filters.resType ? filters.resType : null,
      transStatusId: "U",
      resStatusIds: filters.resStatusIds.length > 0 ? filters.resStatusIds : ['C', 'X'],
    }).subscribe(res => {
      this.monthlyInvoice = res['result'] || this.defaultData;
      setTimeout(() => { this.spinner.hide(); }, 1000);
    })
  }

  onReset() {

    this.filters_form.reset({
      startDate:  null,
      endDate: null,
      resType: null,
      transStatusId: "U",
      resStatusIds: []
    });
    this.isShow = false;
    this.searchText = '';
    this.init();
  }
  dateTranfor(date) {
    return moment(date).utc().format('YYYY-MM-DD');
  }
}
